export default __webpack_public_path__ + "static/gradient-hero-left-29ab6e2e8ec2e24e644ad11ad34d8f97.svg";